import DataStore from "@shared/services/DataStore";
import {I18n} from "../LangUtil";
const KWT = {
  getIdOpts(){
    return {
      label: I18n('g.lbl.civilid'),
      sizeRange: [12,12]
    }
  },
  getTenantInfo(){
    return {
      name: I18n('g.lbl.almulla')
    }
  },
  getMessages(){
    return {
      blackListedMsg: I18n('g.msg.blacklistedcustomer'),
      additionalRemittanceThxText: I18n('g.lbl.addthx')
    }
  },
  getSupportInfo(){
    return {
      custPhone: DataStore.getData().customerCareDetails.custPhone,
      custEmail: DataStore.getData().customerCareDetails.custEmail,
      time: DataStore.getData().customerCareDetails.time
    }
  },
  getThankyouText(){
    return I18n('g.lbl.thx');
  }
};

export default KWT;
